// @ vendors
import React, { useEffect } from 'react';

require('./hireCardOpenCreditStepINEDIR.scss');

// // @ helpers
const { FormattedText } = require('core/i18n').i18n;
import { recordPage, recordLinkV2 } from 'utilities/tagging';
import { 
    PAYMENT_METHOD_CHANGE_ACTION_CLICK,
    PAYMENT_METHOD_CHANGE_ACTION_LINK,
    PAYMENT_METHOD_CHANGE_ACTION_BUTTON,
    PAYMENT_METHOD_CHANGE_FORMAT_LINK,
    PAYMENT_METHOD_CHANGE_FORMAT_BUTTON,
    PAYMENT_METHOD_CHANGE_FORMAT_DOCUMENTS,
    PAYMENT_METHOD_CHANGE_EVENT_LABEL_OPEN_DOCUMENTS
} from 'constants/tagging';

import { Documentation } from "./documentation/Documentation"
import { LoadingSection } from "commonsComponents/loadingSection"

export const HireCardOpenCreditStepINEDIR = ({
    precontractualLabel,
    onAcceptAllDocument,
    allDocumentRead,
    initialDocumentList,
    onSavedocumentAcceptance,
    saveDocumentList,
    checkRadioButtonIneDir,
    taggingData,
    pageName = ''
}) => {

    useEffect(() => {
        if (taggingData) {
            recordPage(taggingData)
        }
    }
    , []);

    const handleSabeDocumentAcceptance = ({ dmsDocumentType }) => {
        onSavedocumentAcceptance({ documentType: dmsDocumentType })
    }

    if (initialDocumentList.size < 2) {
        return (
            <LoadingSection />
        )
    }

    const onClickDocumentItem = (document, documentName) => {
        if (document && pageName) {
            recordLinkV2({
                action: PAYMENT_METHOD_CHANGE_ACTION_CLICK,
                format: PAYMENT_METHOD_CHANGE_FORMAT_LINK,
                component: PAYMENT_METHOD_CHANGE_FORMAT_DOCUMENTS,
                element: documentName,
                eventCategory: pageName,
                eventAction: PAYMENT_METHOD_CHANGE_ACTION_LINK,
                eventLabel: documentName
            });
        }
    }

    const onClickDocumentationButton = () => {
        if (pageName) {
            recordLinkV2({
                action: PAYMENT_METHOD_CHANGE_ACTION_CLICK,
                format: PAYMENT_METHOD_CHANGE_FORMAT_BUTTON,
                component: PAYMENT_METHOD_CHANGE_FORMAT_DOCUMENTS,
                element: PAYMENT_METHOD_CHANGE_EVENT_LABEL_OPEN_DOCUMENTS,
                eventCategory: pageName,
                eventAction: PAYMENT_METHOD_CHANGE_ACTION_BUTTON,
                eventLabel: PAYMENT_METHOD_CHANGE_EVENT_LABEL_OPEN_DOCUMENTS
            });
        }
    };

    return (
        <>
            <div className="mortgage-request-holder-confirmation__title">
                <FormattedText value="hireCardCreditCardINEDIR-titlePage" />
            </div>
            <div className="mortgage-request-holder-confirmation__subtitle">
                <FormattedText value="hireCardCreditCardINEDIR-subtitlePage" />
                <Documentation
                    initialDocumentsList={initialDocumentList}
                    onSaveDocumentAcceptance={handleSabeDocumentAcceptance}
                    precontractualLabel={precontractualLabel}
                    onAcceptAllDocument={onAcceptAllDocument}
                    allDocumentRead={allDocumentRead}
                    saveDocumentList={saveDocumentList}
                    checkRadioButtonIneDir={checkRadioButtonIneDir}
                    onClickDocumentItem= {onClickDocumentItem}
                    onClickDocumentationButton={onClickDocumentationButton}
                />
            </div>
        </>
    )
}
